<template>
  <div class="container-box">
    <div class="header">
      任务详情
      <van-count-down
        v-if="time > 0"
        :time="time"
        class="count-down"
        @finish="handleCountDownFinish"
      >
        <template #default="timeData">
          <span class="block">倒计时: </span>
          <span class="block">{{ timeData.minutes * 60 + timeData.seconds }}秒</span>
        </template>
      </van-count-down>
    </div>
    <div class="body">
      <img :src="taskSubmitInfo.productPicture" alt="" width="100%"/>
      <div class="goods-name">{{ taskSubmitInfo.productName }}</div>
      <div class="order-no">
        <span>订单号：</span>
        <span>{{ $route.query.id }}</span>
        <span class="copy" @click="copy">复制</span>
      </div>
      <template>
        <template v-if="taskSubmitInfo.taskState === '1'">
          <label for="file-input" class="btn upload">
            <input id="file-input" type="file" accept="image/*" @change="handleFileChange" />
            <span>上传周转码</span>
          </label>
          <div class="btn" @click="payTaskSubmit">
            <span>去支付</span>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>
<script>
  import AJAX from "@/utils/AJAX.js";
  import VueQr from "vue-qr";
  import {Dialog, Toast} from "vant";
  import router from "@/router";
  export default {
    components: {
      VueQr,
    },
    data() {
      return {
        loading: true,
        time: 0,
        taskSubmitInfo: {},
        orderInfo: {
          amount: 0
        },
        disabled: false,
        showUpload: false
      }
    },
    mounted() {
      Dialog.alert({
        title: '温馨提示',
        message: '<div style="text-align: left">1、点击(<span style="color: #1677FF;">支付中</span>)，' +
            '2、选择支付宝周转码（<span style="color: red;">保存图片不可截图</span>）' +
            '3、返回浏览器点击(<span style="color: red;">上传图片</span>)并</span>' +
            '4、(<span style="color: red;">复制订单号和码</span>)，发给主持结算佣金<br/><br/>' +
            '<strong style="color: red;">注意‼️一号一天做一单，重复不结算佣金</strong>' +
            '</div>',
        confirmButtonText: '我知道了',
      })
      this.getTaskSubmitInfo();
    },
    methods: {
      getTaskSubmitInfo() {
        const { id } = this.$route.query;
        AJAX.getTaskSubmitInfo({ id })
          .then((res) => {
            if (res.success) {
              const { timeCountDown, timeCountDownMax } = res.result;
              const diff = timeCountDownMax - timeCountDown;
              const newResult = { ...res.result };
              if (diff > 0) {
                this.time = diff;
              } else {
                this.time = 0;
                newResult.taskState = '3'
              }
              this.taskSubmitInfo = newResult;
            }
          });
      },
      copy() {
        this.$copyText(this.taskSubmitInfo.id).then(() => {
          Toast({
            type: 'success',
            message: '复制成功',
            position: 'bottom'
          });
        });
      },
      async payTaskSubmit() {
        const { id } = this.taskSubmitInfo;
        await AJAX.offlineSubmitPay({
          submitId: id,
        })
        window.location.href = `alipays://platformapi/startapp?appId=20000067&url=${encodeURIComponent(`https://res.wangyyapp.com/pay?id=${this.taskSubmitInfo.id}`)}`
        setTimeout(() => {
          this.showUpload = true
        }, 3000);
      },
      handleCountDownFinish() {
        this.time = 0;
        const { activityId } = this.taskSubmitInfo;
        router.push(`/taskPublish?id=${activityId}`);
      },
      handleFileChange(e) {
        const that = this;
        const { id } = this.taskSubmitInfo;
        const formData = new FormData();
        formData.append('image', e.target.files[0]);
        Toast.loading({
          message: '上传中...',
          forbidClick: true,
          duration: 0, // 持续显示
        });
        AJAX.fileUpload(formData).then(res => {
          if (res.success) {
            const params = { id, imageUrl: res.message };
            AJAX.uploadOfflineTaskSubmit(params).then(uploadRes => {
              Toast.clear(true);
              if (uploadRes.success) {
                Toast({
                  type: 'success',
                  message: '周转码上传成功',
                  position: 'bottom'
                });
                that.getTaskSubmitInfo();
              } else {
                Toast({
                  type: 'fail',
                  message: '周转码上传失败',
                  position: 'bottom'
                });
              }
            }).catch(() => {
              Toast.clear(true);
            })
          }
        }).catch(() => {
          Toast.clear(true);
        });
        //
      }
    }
  }
</script>

<style scoped>
  .container-box {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .header {
    position: relative;
    width: 100%;
    height: 44px;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.001), rgba(0, 0, 0, 0.001)), #FF8C00;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    font-size: 18px;
    font-weight: 600;
    line-height: 44px;
    text-align: center;
    color: #FFFFFF;
    .count-down {
      position: absolute;
      right: 12px;
      bottom: 0;
      top: 50%;
      transform: translateY(-50%);
      font-size: 16px;
      color: #ffffff;
      font-weight: bolder;
    }
  }
  .body {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .goods-name {
      width: calc(100% - 16px);
      margin: 12px 8px;
      padding: 12px;
      position: relative;
      background: linear-gradient(270deg, #F6DFB8 0%, #F7ECD5 100%);
      box-sizing: border-box;
      border-radius: 8px;
      color: rgb(34, 31, 24);
      font-size: 15px;
      font-weight: bold;
      line-height: 20px;
    }
    .order-no {
      width: calc(100% - 24px);
      display: flex;
      align-items: center;
      margin-top: 12px;
      .copy {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        height: 24px;
        margin-left: 12px;
        border-radius: 4px;
        padding: 0 12px;
        background: #FFEDD5;
        font-size: 12px;
        line-height: 24px;
        text-align: center;
        color: #333;
      }
    }
    .btn {
      width: calc(100% - 30px);
      height: 48px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 24px;
      border-radius: 4px;
      background: #1677FF;
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      color: #FFFFFF;
      &.upload {
        display: flex;
        background-color: #ebebeb;
        color: red;
        font-weight: bolder;
        #file-input {
          display: none !important;
        }
      }
    }
  }
  .message {
    position: fixed;
    z-index: 1000;
    background-color: #409eff;
    top: 60px;
    left: 50%;
    transform: translateX(-50%);
    padding: 4px 12px;
    border-radius: 6px;
    color: #ffffff;
    box-shadow: 0 0 12px rgba(0, 0, 0, .12);
  }
</style>
